import { makeVar } from '@apollo/client'

export const isOfflineDialogOpenVar = makeVar(false)
export const isBetaWelcomeDialogOpenedVar = makeVar(false)
export const isBannerMessageModalOpenVar = makeVar(false)
